import { Body, Controller, Post } from '@nestjs/common';
import {  CommonResponseModel } from '@needle-management/shared-models';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { MaterialRequestRepository } from './material-request-repo';
import { MaterialRequestService } from './material-request-service';
import { MaterialRequestDTO } from './material-request-dto';
import { ApplicationExceptionHandler } from 'packages/backend-utils/src/lib/exception-handling/application-exception-handler';



@Controller('/material-request')
@ApiTags('/material-request')
export class MaterialRequestController {
    constructor(
        private service: MaterialRequestService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler
        
    ) {}

    @Post('/createMaterialRequest')
    @ApiBody({ type: MaterialRequestDTO })
    async createMaterialRequest(@Body() req:any ,isUpdate:boolean=false): Promise<CommonResponseModel> {
        return await this.service.createMaterialRequest(req,false);
    }

    @Post('/getMaterialRequest')
      async getMaterialRequest(): Promise<CommonResponseModel> {
          try {
            return await this.service.getMaterialRequest();
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
          }
      }
    

}
